import { useEffect, useMemo, useRef, useState } from "react";
import FormFilter from "./components/FormFilter";
import TableList from "./components/TableList";
import userApi from "api/user";
import style from "./index.module.scss";
import classNames from "classnames/bind";
import { Button, notification, Tooltip } from "antd";
import ModalCreated from "./components/ModalCreated";
import shopApi from "api/shop";
import { ROLE, roleKeys, roles } from "../../constants";
import { getUser } from "utils/index";
import { UserAddOutlined } from '@ant-design/icons';
import { useTranslation } from "react-i18next";
import { rolesAddEmployee } from "./roles";

const cx = classNames.bind(style);

export default function Users() {
  const [users, setUsers] = useState([]);
  const [dataTable, setDataTable] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [optionsStore, setOptionsStore] = useState([]);

  const { t } = useTranslation()

  const [api, contextHolder] = notification.useNotification();

  const openNotificationWithIcon = (type, message, description) => {
    api[type]({ message, description });
  };

  const getUsers = async () => {
    try {
      setLoading(true)
      const res = await userApi.getUsers();
      if (res.success) {
        setUsers(res.users);
        setDataTable(res.users);
      }
    } catch (error) {

    } finally {
      setLoading(false);
    }
  };

  const getStore = async () => {
    try {
      const res = await shopApi.getShopByRole();
      if (getUser().role == roles.admin) {
        setOptionsStore(
          res.shops.map((shop) => ({
            value: shop.shopId,
            label: shop.shopName,
          }))
        );
      } else {
        setOptionsStore(
          res.shops.map((shop) => ({
            value: shop.shop._id,
            label: shop.shop.name,
          }))
        );
      }
    } catch (error) {

    }
  };

  const optionsRole = useMemo(() => {
    const res = []
    Object.keys(ROLE).map((key) => {
      if ((getUser().role == roles.departmentManager && key == roles.departmentManager) || getUser().role >= key) {

      } else {
        res.push({
          value: key,
          label: t(roleKeys[key]),
        });
      }

    })

    return res
  }, [t]);

  useEffect(() => {
    getUsers();
    getStore();
  }, []);

  const ref = useRef();

  const onSearch = () => {
    ref.current.onSearch();
  }

  return (
    <div className={cx("page-user")}>
      {contextHolder}
      <div className={cx("title")}>
        <p>{t('listEmployee')}</p>
        {
          rolesAddEmployee.includes(+getUser().role) &&
          <Button onClick={() => setOpenModal(true)}>  <Tooltip title={t('addEmployee')}>
            <UserAddOutlined />
          </Tooltip></Button>
        }
      </div>
      <FormFilter
        ref={ref}
        setDataTable={setDataTable}
        users={users}
        optionsStore={optionsStore}
        optionsRole={optionsRole}
        getUser={getUsers}
      />
      <TableList
        loading={loading}
        setDataTable={setDataTable}
        users={dataTable}
        optionsStore={optionsStore}
        optionsRole={optionsRole}
        openNotificationWithIcon={openNotificationWithIcon}
        onSearch={onSearch}
      />
      <ModalCreated
        onSearch={onSearch}
        openNotificationWithIcon={openNotificationWithIcon}
        setOpenModal={setOpenModal}
        openModal={openModal}
        isCreated
        optionsRole={optionsRole}
        optionsStore={optionsStore}
        getUser={getUsers}
      />
    </div>
  );
}
